import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editor"]

  toggle() {
    this.displayTarget.classList.toggle("hidden")
    this.editorTarget.classList.toggle("hidden")
  }
}
